module.exports = __webpack_public_path__ + "static/media/SF-9-A (1).626d464b.mp3";